import { render } from "./FilePreview.vue?vue&type=template&id=57385df6"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"

import "./FilePreview.vue?vue&type=style&index=0&id=57385df6&lang=css"

import exportComponent from "/home/runner/work/origins-memo/origins-memo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__